type TProps = {
    fullName: string;
}

const Title = ({fullName}: TProps) => {
    return (
        <div className="cr-title cr-text-lg cr-text-primary cr-bold">{fullName}</div>
    )
}

export default Title;
